<p-dialog styleClass="img-preview" [(visible)]="isShowPreviewImg" [modal]="true" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" (onHide)="previewImg = {}">
    <ng-template pTemplate="header">
      <div class="header-title">
        <p-button icon="pi pi-download" styleClass="p-button-rounded" (click)="downloadFile(previewImg.path)"></p-button>
      </div>
    </ng-template>
    <img [src]="previewImg.path" [alt]="previewImg.name">
</p-dialog>
